import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getCruisePurchasesInput,
  getCruisePurchaseInput,
  CruisePurchaseLiteModel,
  CruisePurchaseModel,
} from './model';

export function useGetCruisePurchases(
  input?: getCruisePurchasesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<CruisePurchaseLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<CruisePurchaseLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCruisePurchases', input?.params],
      () =>
        QueryFetchFunction({
          url: 'cruise-purchases',
          params: input?.params,
        }),
      options,
    ),
    CruisePurchaseLiteModel,
  );
}

export function useGetCruisePurchase(
  input?: getCruisePurchaseInput,
  options?: UseQueryOptions<ApiResult<CruisePurchaseModel>, ApiError>,
): UseQueryResult<ApiResult<CruisePurchaseModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getCruisePurchase', input?.id],
      () => QueryFetchFunction({ url: `cruise-purchases/${input?.id}` }),
      options,
    ),
    CruisePurchaseModel,
  );
}

export function getCruisePurchasesKey(input?: getCruisePurchasesInput) {
  return ['getCruisePurchases', input?.params];
}

export function getCruisePurchaseKey(input?: getCruisePurchaseInput) {
  return ['getCruisePurchase', input?.id];
}
